import MatClickAwayListener from '@mui/material/ClickAwayListener'
import PropTypes from 'prop-types'

const ClickAwayListener = (props) => {
  const { children, mouseEvent, onClickAway, touchEvent, ...other } = props
  return (
    <MatClickAwayListener
      mouseEvent={mouseEvent}
      onClickAway={onClickAway}
      touchEvent={touchEvent}
      {...other}
    >
      {children}
    </MatClickAwayListener>
  )
}

ClickAwayListener.propTypes = {
  children: PropTypes.element.isRequired,
  mouseEvent: PropTypes.oneOf(['onClick', 'onMouseDown', 'onMouseUp', false]),
  onClickAway: PropTypes.func.isRequired,
  touchEvent: PropTypes.oneOf(['onTouchStart', 'onTouchEnd', false]),
}

export default ClickAwayListener
